import React from 'react';
import { Menu } from './menu';
import WhatsApp from './assets/whatsapp.png';
import Phone from './assets/phone.png';
import { getWhatsAppLink, PHONE_NUMBER_WITH_PREFIX } from './utils/constants';


function App() {
  return (
    <div className='App '>
      <Menu />
      <a href={getWhatsAppLink()} target='_blank' rel="noreferrer" className='whatsApp'>
        <img src={WhatsApp} alt='Shivay Durga' width={36} height={36} />
      </a>
      <a href={`tel:${PHONE_NUMBER_WITH_PREFIX}`}>
        <img src={Phone} alt='Contact Us' width={36} height={36} className='callToAction' />
      </a>
    </div>
  );
}

export default App;
